import type { FeatureFlagValues } from 'infrastructure/features/types';
import type { AdSettings } from 'slices/SettingsV2/types';

export const ADS_ANALYTICS_ROUTE = '/ads-analytics';
export const ADS_ANALYTICS_FALLBACK_ROUTE = '/analytics';
export const FIRST_PARTY_ADS_FEATURE_FLAG = 'useFirstPartyAds';

interface CanAccessAdsAnalyticsArgs {
  adsFrom?: AdSettings['adsFrom'] | null;
  featureFlags?: FeatureFlagValues | null;
}

export const canAccessAdsAnalytics = ({
  adsFrom,
  featureFlags,
}: CanAccessAdsAnalyticsArgs) =>
  adsFrom === 'storyteller' ||
  featureFlags?.[FIRST_PARTY_ADS_FEATURE_FLAG] === true;
